

    import Vue from "vue";
    import Component from "vue-class-component";

    import hljs from "highlight.js/lib/core";
    import javascript from "highlight.js/lib/languages/javascript";
    import "@/css/code-highlight.css";

    @Component({})
    export default class PublicApiDocs extends Vue {

        mounted() {
            hljs.registerLanguage("javascript", javascript);

            hljs.highlightElement((this.$refs.example0) as HTMLElement);
            hljs.highlightElement((this.$refs.example1) as HTMLElement);
            hljs.highlightElement((this.$refs.example2) as HTMLElement);
            hljs.highlightElement((this.$refs.example3) as HTMLElement);
        }

        rootUrl = `${window.location.protocol}//${window.location.host}/api/`;
    }
